import { ContactRoleKey } from '@/core/collections/contracts-api/customers/contacts/contact.interface';
import store from '../store';

function checkAccess(requiredScopes: Array<string> | string, userScopes: Array<string> = []) {
   if (Array.isArray(requiredScopes)) {
      return requiredScopes.every((requiredScope) => userScopes.includes(requiredScope));
   }
   return userScopes.includes(requiredScopes);
}

function checkAddon(requiredAddons: Array<string> | string, userAddons: Array<string> = store.state.userInfo?.userInfo?.addons || []) {
   if (Array.isArray(requiredAddons)) {
      return requiredAddons.every((requiredAddon) => userAddons.includes(requiredAddon));
   }
   return userAddons.includes(requiredAddons);
}

function checkContactRole(requiredRoleKeys: ContactRoleKey | ReadonlyArray<ContactRoleKey>, matchMode: 'and' | 'or' = 'or') {
   const userInfo = store.state.userInfo?.userInfo;
   if (!userInfo?.contacts) return false;

   const roleKeys = Array.isArray(requiredRoleKeys) ? requiredRoleKeys : [requiredRoleKeys];
   if (roleKeys.length === 0) return false;

   const hasRole = (roleKey: ContactRoleKey) =>
      userInfo.contacts.some((contact: any) => contact.contact_roles?.some((role: any) => role.key === roleKey));

   if (matchMode === 'and') {
      return roleKeys.every(hasRole);
   }

   return roleKeys.some(hasRole);
}

export { checkAccess, checkAddon, checkContactRole };
